import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import ReactMarkdown from 'react-markdown'; // ★ Markdownのレンダリング
import remarkGfm from 'remark-gfm'; // ★ テーブルやリンクを正しく処理
import { postsApi } from '../services/api';
import Layout from './Layout';
import rehypeRaw from 'rehype-raw'; // npm install rehype-raw
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';


export default function PostDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await postsApi.getPost(id);
        console.log("取得した記事データ:", response.data); //APIレスポンスを確認
        setPost(response.data);
      } catch (err) {
        setError('記事の読み込みに失敗しました');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [id]);

  return (
    <Layout>
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 4, mt: -3 }}>
        <Box sx={{
          flex: { xs: '1 1 100%', md: '1 1 75%' },
          bgcolor: 'background.paper',
          p: 3,
          borderRadius: 1,
          // boxShadow: 1
        }}>

          {/* 戻るボタン */}
          <Box sx={{ mb: 2 }}>
            <Button variant="outlined" onClick={() => navigate(-1)}>
              ← 戻る
            </Button>
          </Box>

          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
              <CircularProgress />
            </Box>
          ) : error ? (
            <Typography color="error">{error}</Typography>
          ) : (
            post && (
              <Box>

                {/* 日付とカテゴリーを横並びに配置 */}
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                  <Typography variant="subtitle1" color="text.secondary" >
                    {new Date(post.created_at).toLocaleDateString('ja-JP')}
                  </Typography>

                  <Typography variant="subtitle1" color="text.secondary">
                    [{post.category}]
                  </Typography>
                </Box>

                <Typography variant="h4" component="h1" >
                  {post.title}
                </Typography>

                <Box sx={{ mt: 5 }}>
                  {/* <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeRaw]} 
                  >
                    {post.content}
                  </ReactMarkdown> */}

                  <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeRaw]}
                    components={{
                      img: ({ node, ...props }) => (
                        <img
                          style={{ maxWidth: '100%', height: 'auto' }}
                          {...props}
                        />
                      ),
                      a: ({ node, ...props }) => (
                        <a {...props} style={{ wordBreak: 'break-all' }} />
                      )
                    }}
                  >
                    {post.content}
                  </ReactMarkdown>

                </Box>
              </Box>
            )
          )}
        </Box>
      </Box>
    </Layout>
  );
}